import { FunctionComponent } from 'react';
import amex from './Logos/AMEX.svg';
import discover from './Logos/Discover.svg';
import mastercard from './Logos/MasterCard.svg';
import unionpay from './Logos/UnionPay.svg';
import visa from './Logos/Visa.svg';
import Icon from '../Icon/Icon';
import { CardBrand } from '../../Utility/VoPayApi/VoPayApi.types';

type Top5CardBrands = Extract<CardBrand, 'mastercard' | 'visa' | 'discover' | 'amex' | 'unionpay'>;

export type CardLogoProps = {
  width: string;
  height: string;
  cardBrand?: CardBrand;
};

const cardIconMap: Record<Top5CardBrands, { src: string; alt: string }> = {
  mastercard: { src: mastercard, alt: 'Master Card' },
  visa: { src: visa, alt: 'Visa' },
  amex: { src: amex, alt: 'American Express' },
  discover: { src: discover, alt: 'Discover' },
  unionpay: { src: unionpay, alt: 'UnionPay' },
};

const CardLogo: FunctionComponent<CardLogoProps> = ({ width, height, cardBrand }) => {
  if (isTop5Logo(cardBrand)) {
    const cardIcon = cardIconMap[cardBrand];

    return <img style={{ width, height, borderRadius: '50px' }} src={cardIcon.src} alt={cardIcon.alt} />;
  }

  return <Icon icon="creditCard4" width={width} height={height} color="none" />;
};

export default CardLogo;

function isTop5Logo(logo?: CardBrand): logo is Top5CardBrands {
  return logo !== undefined && logo in cardIconMap;
}
